module.exports = __webpack_public_path__ + "static/gnome_forest_druid_female_SCAG-634fa1af51b009a5a26a53fed701d156.jpg";